<template>
    <div class="information">
        <div class="content-wrapper">
            <div class="text-content">
                <h2>{{info.title }}</h2>
                <p class="light">{{ info.date }}</p>
                <p v-html="info.description"></p>
            </div>
            <img v-if="info.img" :src="info.img" :alt="info.title" class="info-image">
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoContainer",
    props: ['info']
}
</script>

<style scoped>
:root {
  --backgroundColor: #dcdece;
  --mainText: #333D29;
  --mainTextLight: #70875A;
  --linkText: #936639;
  --focusedText: #582F0E;
  --higlightedText: #04A0A2;
}

p.light {
    margin-bottom: 16px;
    color: var(--mainTextLight);
}

h2 {
    margin-bottom: 0px;
}

.information {
    margin-bottom: 32px;
}

.content-wrapper {
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

.text-content {
    flex: 1;
    min-width: 0;
}

.info-image {
    max-width: 30%;
    height: auto;
    flex-shrink: 0;
    border-radius: 6px;
}

</style>